import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { companyService } from '@/services/api'

// Authentication views
import Login from '@/views/Auth/Login.vue'
import VerifyOtpLogin from '@/views/Auth/VerifyOtpLogin.vue'
import Register from '@/views/Auth/Register.vue'
import VerifyOtp from '@/views/Auth/VerifyOtp.vue'
import SetPassword from '@/views/Auth/SetPassword.vue'
import ResetNewPassword from '@/views/Auth/ResetNewPassword.vue'
import ResetPasswordOtp from '@/views/Auth/ResetPasswordOtp.vue'
import ResetPasswordPhone from '@/views/Auth/ResetPasswordPhone.vue'

// Customer views
import Dashboard from '../views/Customer/Dashboard.vue'
import Factors from '@/views/Customer/Factors.vue'
import TaahodatY from '@/views/Customer/TaahodatY.vue'
import TaahodatO from '@/views/Customer/TaahodatO.vue'
import KalaO from '@/views/Customer/Kala/KalaO.vue'
import KalaY from '@/views/Customer/Kala/KalaY.vue'
import CheckInquiry from '@/views/Customer/CheckInquiry.vue'

// Employer views
import EmployerDashboard from '@/views/Employer/Dashboard.vue'
import Traz from '@/views/Employer/Traz.vue'
import TrazAnalysis from '@/views/Employer/TrazAnalysis.vue'
import CustomerSearch from '@/views/Employer/CustomerSearch.vue'
import CustomerFactors from '@/views/Employer/CustomerFactors.vue'
import ReportMande from '@/views/Employer/ReportMande.vue'
import ReportMande2 from '@/views/Employer/ReportMande2.vue'
import TaseerSood from '@/views/Employer/TaseerSood.vue'
import RegisterCompanyPhone from '@/views/Auth/RegisterCompanyPhone.vue'
import KalaStore from '@/views/Customer/Sales/KalaStore.vue'
import ChatWidget from '@/views/Messanger/ChatWidget.vue'
import LiquidityRatio from '@/views/Employer/LiquidityRatio.vue'
import KalaSearch from '@/views/Employer/Kala/KalaSearch.vue'
import DepotCardDetail from '@/views/Employer/Kala/DepotCardDetail.vue'

// Operator views
import OperatorPanel from '@/views/Messanger/OperatorPanel.vue'

// SystemAdmin views
import AdminDashboard from '@/views/SystemAdmin/Dashboard.vue'
import OperatorManagement from '@/views/SystemAdmin/OperatorManagement.vue'
import CompanyManagement from '@/views/SystemAdmin/CompanyManagement.vue'
import UserManagement from '@/views/SystemAdmin/UserManagement.vue'
//import AdminCompanyPermissions from '@/views/SystemAdmin/AdminCompanyPermissions.vue'
//import AdminCompanyPermissions from '@/views/SystemAdmin/AdminCompanyPermissions.vue'

// Accountant Views
import AccountantDashboard from '@/views/Accountant/Dashboard.vue'
import AccountantCustomerSearchSorat from '@/views/Accountant/CustomerSearchSoratHesab.vue'
import AccountantCustomerSearchStore from '@/views/Accountant/CustomerSearchStore.vue'
import AccountantCustomerFactors from '@/views/Accountant/CustomerFactors.vue'
import AccountantKalaStore from '@/views/Accountant/Sales/KalaStore.vue'
import AccountantCategoryPage from '@/views/Accountant/Sales/CategoryPage.vue'
import KalaSearch1 from '@/views/Accountant/KalaSearch.vue'
import ReportMande1 from '@/views/Accountant/ReportMande.vue'
import AccountantDepotCardDetail from '@/views/Accountant/DepotCardDetail.vue'
import AccountantCustomerOrdersTest from '@/views/Accountant/CustomerOrdersTest.vue'

// General views
import SelectCompany from '@/views/Auth/SelectCompany.vue'
import NotFound from '@/views/NotFound.vue'
import SelectRole from '@/views/Auth/SelectRole.vue'
import CompaniesLanding from '@/views/CompaniesLanding.vue'
import SalesForm from '@/views/Customer/Sales/SalesForm.vue'
import Payment from '@/views/Customer/Sales/Payment.vue'
import PaymentVerification from '@/views/Customer/PaymentVerification.vue'
import LandingErp from '@/views/landingErp.vue'
import landingKhaneNarm from '@/views/landingKhaneNarm.vue'
import TestLetterForm from '@/views/TestLetterForm.vue'
import CheckTransferForm from '@/views/CheckTransferForm.vue'

// Peak views
import RegisterDriver from '@/views/Peak/RegisterDriver.vue'
import CustomerDelivery from '@/views/Peak/CustomerDelivery.vue'
import DriverDeliveries from '@/views/Peak/DriverDeliveries.vue'
import AdminAllCompanies from '@/views/SystemAdmin/AdminAllCompanies.vue'
import CategoryPage from '@/views/Customer/Sales/CategoryPage.vue'
import InvoiceList from '@/views/Customer/Sales/InvoiceList.vue'
import DailyReportDetail from '@/views/Employer/DailyReportDetail.vue'
import TrazSood from '@/views/Employer/TrazSood.vue'

// Office views
import OfficeDashboard from '@/views/Office/Dashboard.vue'
import OfficeLetters from '@/views/Office/OfficeLetters.vue'

// Employee views
import EmployeeDashboard from '@/views/Employee/Dashboard.vue'
import EmployeeLetters from '@/views/Office/OfficeLetters.vue'


const resolveCompanyRoute = async (to, from, next) => {
  const companyName = to.params.companyName
  
  try {
    const response = await companyService.getCompanyByName(companyName)
    if (response.data.success) {
      // Add company data to route meta for the component
      to.meta.companyId = response.data.data.id
      to.meta.companyName = response.data.data.name
      
      // Check if this is "خانه نرم افزار" and redirect to a different component
      if (companyName === 'خانه نرم افزار' || companyName === 'خانه-نرم-افزار' || 
          response.data.data.name === 'خانه نرم افزار') {
        // Redirect to a different route
        next({ 
          name: 'KhaneNarmLanding', 
          params: { companyName: companyName },
          // Preserve the meta data
          state: { 
            companyId: response.data.data.id,
            companyName: response.data.data.name 
          }
        })
      } else {
        next()
      }
    } else {
      next({ name: 'NotFound' })
    }
  } catch (error) {
    console.error('Error resolving company:', error)
    next({ name: 'NotFound' })
  }
}

const routes = [
  { 
    path: '/', 
    name: 'Home', 
    component: LandingErp,
    meta: { 
      requiresAuth: false,
      title: 'Home'
    }
  },
  { 
    path: '/company/khane-narm', 
    name: 'KhaneNarmLanding', 
    component: landingKhaneNarm,
    meta: { 
      requiresAuth: false,
      title: 'Khane Narm Landing'
    }
  },
  { 
    path: '/landing', 
    name: 'Landing', 
    component: LandingErp,
    meta: { 
      requiresAuth: false,
      title: 'Landing'
    }
  },
  { 
    path: '/dashboard', 
    name: 'CustomerDashboard', 
    component: Dashboard,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Customer Dashboard'
    }
  },
  { 
    path: '/login', 
    name: 'Login', 
    component: Login,
    meta: { 
      requiresAuth: false, 
      hideWhenAuthenticated: true,
      title: 'Login'
    }
  },
  {
    path: '/peak',
    name: 'Peak',
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Peak'
    },
    children: [
      { 
        path: 'register-driver', 
        name: 'RegisterDriver', 
        component: RegisterDriver,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['customer'],
          title: 'RegisterDriver'
        }
      },
      { 
        path: 'customer-delivery', 
        name: 'CustomerDelivery', 
        component: CustomerDelivery,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['customer'],
          title: 'CustomerDelivery'
        }
      },
      { 
        path: 'driver', 
        name: 'Driver', 
        component: DriverDeliveries,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['customer'],
          title: 'Driver'
        }
      },
    ]
  },
  { 
    path: '/verifyOtpLogin', 
    name: 'VerifyOtpLogin', 
    component: VerifyOtpLogin,
    meta: { 
      requiresAuth: false, 
      hideWhenAuthenticated: true,
      title: 'Verify OTP'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { 
      requiresAuth: false, 
      hideWhenAuthenticated: true,
      title: 'Register'
    }
  },
  {
    path: '/verify-otp',
    name: 'VerifyOtp',
    component: VerifyOtp,
    meta: { 
      requiresAuth: false, 
      hideWhenAuthenticated: true,
      title: 'Verify OTP'
    }
  },
  {
    path: '/set-password',
    name: 'SetPassword',
    component: SetPassword,
    meta: { 
      requiresAuth: false, 
      hideWhenAuthenticated: true,
      title: 'Set Password'
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPasswordPhone',
    component: ResetPasswordPhone,
    meta: { 
      requiresAuth: false, 
      hideWhenAuthenticated: true,
      title: 'Reset Password Phone'
    }
  },
  {
    path: '/register-company-phone',
    name: 'RegisterCompanyPhone',
    component: RegisterCompanyPhone,
    props: (route) => ({
      company: {
        company_id: route.query.companyId,
        company_name: route.query.companyName
      }
    })
  },
  {
    path: '/reset-otp',
    name: 'ResetPasswordOtp',
    component: ResetPasswordOtp,
    meta: { 
      requiresAuth: false, 
      hideWhenAuthenticated: true,
      title: 'Reset Password Otp'
    }
  },
  {
    path: '/reset-new-password',
    name: 'ResetNewPassword',
    component: ResetNewPassword,
    meta: { 
      requiresAuth: false, 
      hideWhenAuthenticated: true,
      title: 'Reset Password'
    }
  },
  {
    path: '/factors',
    name: 'Factors',
    component: Factors,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Factors'
    }
  },
  {
    path: '/taahodat-y',
    name: 'TaahodatYour',
    component: TaahodatY,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Your Taahodat'
    }
  },
  {
    path: '/taahodat-o',
    name: 'TaahodatOur',
    component: TaahodatO,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Our Taahodat'
    }
  },
  {
    path: '/kala-o',
    name: 'KalaOur',
    component: KalaO,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Our Kala'
    }
  },
  {
    path: '/kala-y',
    name: 'KalaYour',
    component: KalaY,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Your Kala'
    }
  },
  {
    path: '/invoice-list',
    name: 'InvoiceList',
    component: InvoiceList,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Invoice List'
    }
  },
  {
    path: '/check-inquiry',
    name: 'CheckInquiry',
    component: CheckInquiry,
    meta: { 

      requiresAuth: false,
      // requiresAuth: true,
      // requiredRoles: ['customer'],
      title: 'Check Inquiry'
    }
  },
  {
    path: '/sales-form',
    name: 'SalesForm',
    component: SalesForm,
    meta: { 

      requiresAuth: false,
      // requiresAuth: true,
      // requiredRoles: ['customer'],
      title: 'Sales Form'
    }
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    meta: { 

      requiresAuth: false,
      // requiresAuth: true,
      // requiredRoles: ['customer'],
      title: 'Payment'
    }
  },
  {
    path: '/test/letter-form',
    name: 'TestLetterForm',
    component: TestLetterForm,
    meta: {
      requiresAuth: false,
      title: 'Test Letter Form'
    }
  },
  {
    path: '/check-transfer',
    name: 'CheckTransferForm',
    component: CheckTransferForm,
    meta: {
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Check Transfer Form'
    }
  },
  {
    path: '/payment/verification',
    name: 'PaymentVerification',
    component: PaymentVerification,
    meta: { requiresAuth: false, title: 'Payment verification' }
  },
  {
    path: '/sales/kala-store',
    name: 'SalesKalaStore',
    component: KalaStore,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['store'],
      title: 'Sales Kala Store'
    }
  },
  {
    path: '/category/:id',
    name: 'CategoryPage',
    component: CategoryPage,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['store'],
      title: 'Category Page'
    }
  },
  {
    path: '/messanger',
    name: 'Messanger',
    component: ChatWidget,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Messanger'
    }
  },
  {
    path: '/operator-panel',
    name: 'Operator',
    component: OperatorPanel,
    meta: { 
      requiresAuth: true,
      requiredRoles: ['customer'],
      title: 'Operator Panel'
    },
    props: (route) => ({
      department: route.query.department || 'support',
      companyId: route.query.companyId,
      companyName: route.query.companyName || ''
    })
  },
  {
    path: '/company/:companyName',
    name: 'PublicCompanyLanding',
    component: CompaniesLanding,
    meta: { 
      requiresAuth: false,
      title: 'Company Landing'
    },
    beforeEnter: resolveCompanyRoute,
    props: (route) => ({
      companyName: route.params.companyName,
      companyId: route.meta.companyId
    })
  },
  
  // Also keep ID-based route for backward compatibility
  {
    path: '/company/id/:companyId',
    name: 'PublicCompanyLandingById',
    component: CompaniesLanding,
    meta: { 
      requiresAuth: false,
      title: 'Company Landing'
    },
    props: (route) => ({
      companyId: route.params.companyId
    })
  },
  {
    path: '/employee',
    name: 'Employee',
    meta: { 
      requiresAuth: true,
      requiredRoles: ['VIEWER', 'employee'],
      title: 'Employee'
    },
    children: [
      {
        path: 'dashboard',
        name: 'EmployeeDashboard',
        component: EmployeeDashboard,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['VIEWER', 'employee'],
          title: 'Employee Dashboard'
        }
      },
      {
        path: 'employee-letters',
        name: 'EmployeeLetters',
        component: EmployeeLetters,
        meta: { 

          requiresAuth: true,
          requiredRoles: ['VIEWER', 'employee'],
          title: 'Employee Letters'
        }
      },
    ]
  },
  {
    path: '/office',
    name: 'Office',
    meta: { 
      requiresAuth: true,
      requiredRoles: ['VIEWER', 'office'],
      title: 'Office'
    },
    children: [
      {
        path: 'dashboard',
        name: 'OfficeDashboard',
        component: OfficeDashboard,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['VIEWER', 'office'],
          title: 'Office Dashboard'
        }
      },
      {
        path: 'office-letters',
        name: 'OfficeLetters',
        component: OfficeLetters,
        meta: { 

          requiresAuth: true,
          requiredRoles: ['VIEWER', 'office'],
          title: 'Office Letters'
        }
      },
    ]
  },
  // ========== EMPLOYER ROUTES ==========
  {
    path: '/employer',
    name: 'EmployerBase',
    meta: { 
      requiresAuth: true,
      requiredRoles: ['employer'],
      title: 'Employer'
    },
    children: [
      {
        path: 'dashboard',
        name: 'EmployerDashboard',
        component: EmployerDashboard,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Employer Dashboard'
        }
      },
      {
        path: 'traz',
        name: 'EmployerTraz',
        component: Traz,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Employer Traz'
        }
      },
      {
        path: 'analysis-traz',
        name: 'EmployerAnalysisTraz',
        component: TrazAnalysis,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Employer Analysis Traz'
        }
      },
      {
        path: 'customer-search',
        name: 'CustomerSearch',
        component: CustomerSearch,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Customer Search'
        }
      },
      {
        path: 'customer-factors',
        name: 'CustomerFactors',
        component: CustomerFactors,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Customer Factors'
        }
      },
      {
        path: 'report-mande',
        name: 'ReportMande',
        component: ReportMande,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Report Mande'
        }
      },
      {
        path: 'report-mande2',
        name: 'ReportMande2',
        component: ReportMande2,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Report Mande2'
        }
      },
      {
        path: 'taseer-sood',
        name: 'TaseerSood',
        component: TaseerSood,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Taseer Sood'
        }
      },
      {
        path: 'liquidy-ratio',
        name: 'LiquidyRatio',
        component: LiquidityRatio,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Liquidy Ratio'
        }
      },
      {
        path: 'kala-search',
        name: 'KalaSearch',
        component: KalaSearch,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['employer'],
          title: 'Employer Kala Search'
        }
      },
      {
        path: 'kala-detail/:id',
        name: 'KalaDetail',
        component: DepotCardDetail,
        meta: {
            requiresAuth: true,
            requiredRoles: ['employer'],
            title: 'Employer Kala Detail'
        }
      },
      {
        path: 'daily-report-detail/:act',
        name: 'DailyReportDetail',
        component: DailyReportDetail,
        meta: {
            requiresAuth: true,
            requiredRoles: ['employer'],
            title: 'DailyReportDetail'
        }
      },
      {
        path: '/employer/traz-sood',
        name: 'TrazSood',
        component: TrazSood,
        meta: {
            requiresAuth: true,
            requiredRoles: ['employer'],
            title: 'Traz Sood'
        }
      }
      // Add more employer routes here:
      // {
      //   path: 'jobs',
      //   name: 'EmployerJobs',
      //   component: EmployerJobs,
      //   meta: { 
      //     requiresAuth: true,
      //     requiredRoles: ['employer'],
      //     title: 'Manage Jobs'
      //   }
      // },
      // {
      //   path: 'profile',
      //   name: 'EmployerProfile',
      //   component: EmployerProfile,
      //   meta: { 
      //     requiresAuth: true,
      //     requiredRoles: ['employer'],
      //     title: 'Employer Profile'
      //   }
      // }
    ]
  },
  
  // Redirect from /employer to /employer/dashboard
  {
    path: '/employer',
    redirect: '/employer/dashboard'
  },

  // ========== Accountant ROUTES ==========
  {
    path: '/accountant',
    name: 'AccountantBase',
    meta: { 
      requiresAuth: true,
      requiredRoles: ['accountant'],
      title: 'Accountant'
    },
    children: [
      {
        path: 'dashboard',
        name: 'AccountantDashboard',
        component: AccountantDashboard,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['accountant'],
          title: 'Accountant Dashboard'
        }
      },
      {
        path: 'customer-search-store',
        name: 'AccountantCustomerSearchStore',
        component: AccountantCustomerSearchStore,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['accountant'],
          title: 'Accountant Customer Search Store'
        }
      },
      {
        path: 'customer-search-sorat',
        name: 'AccountantCustomerSearchSoratHesab',
        component: AccountantCustomerSearchSorat,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['accountant'],
          title: 'Accountant Customer Search Sorat'
        }
      },
      {
        path: 'customer-factors',
        name: 'AccountantCustomerFactors',
        component: AccountantCustomerFactors,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['accountant'],
          title: 'Accountant Customer Factors'
        }
      },
      {
        path: 'customer-orders-test',
        name: 'AccountantCustomerOrdersTest',
        component: AccountantCustomerOrdersTest,
        meta: {
          requiresAuth: true,
          requiredRoles: ['accountant'],
          title: 'سفارش‌های مشتریان',
        },
      },
      {
        path: 'kala-store',
        name: 'AccountantKalaStore',
        component: AccountantKalaStore,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['accountant'],
          title: 'Accountant Kala Store'
        }
      },
      {
        path: 'category/:id',
        name: 'AccountantCategoryPage',
        component: AccountantCategoryPage,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['accountant'],
          title: 'Accountant Category Page'
        }
      },
      {
        path: 'kala-search',
        name: 'AccountantKalaSearch',
        component: KalaSearch1,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['accountant'],
          title: 'Accountant Kala Search'
        }
      },
      {
        path: 'report-mande',
        name: 'AccountantReportMande',
        component: ReportMande1,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['accountant'],
          title: 'Accountant Report Mande'
        }
      },
    ]
  },

  // Redirect from /accountant to /accountant/dashboard
  {
    path: '/accountant',
    redirect: '/accountant/dashboard'
  },

  // ========== ADMIN ROUTES ==========
  {
    path: '/admin',
    name: 'AdminBase',
    meta: { 
      requiresAuth: true,
      requiredRoles: ['admin'],
      title: 'Admin'
    },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['admin'],
          title: 'Admin Dashboard'
        }
      },
      {
        path: 'company-management',
        name: 'CompanyManagement',
        component: CompanyManagement,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['admin'],
          title: 'Company Management'
        }
      },
      {
        path: 'user-management',
        name: 'UserManagement',
        component: UserManagement,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['admin'],
          title: 'User Management'
        }
      },
      {
        path: 'operator-management',
        name: 'OperatorManagemant',
        component: OperatorManagement,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['admin'],
          title: 'Operator Management'
        }
      },
      {
        path: 'company-permissions',
        name: 'CompanyPermissions',
        component: AdminAllCompanies,
        meta: { 
          requiresAuth: true,
          requiredRoles: ['admin'],
          title: 'Company Permissions'
        }
      },
      {
        path: 'kala-detail/:id',
        name: 'AccountantKalaDetail',
        component: AccountantDepotCardDetail,
        meta: {
            requiresAuth: true,
            requiredRoles: ['accountant'],
            title: 'Accountant Kala Detail'
        }
      },
    ]
  },
  
  // ========== MULTI-ROLE ACCESS ROUTES ==========
  // Routes that can be accessed by multiple roles
  // {
  //   path: '/profile',
  //   name: 'Profile',
  //   component: () => import('@/views/Profile.vue'), // Lazy load
  //   meta: { 
  //     requiresAuth: true,
  //     requiredRoles: ['customer', 'employer', 'admin'], // All roles can access
  //     title: 'Profile'
  //   }
  // },
  // {
  //   path: '/settings',
  //   name: 'Settings',
  //   component: () => import('@/views/Settings.vue'), // Lazy load
  //   meta: { 
  //     requiresAuth: true,
  //     requiredRoles: ['customer', 'employer', 'admin'],
  //     title: 'Settings'
  //   }
  // },
  
  // ========== ROLE SELECTION (for users with multiple roles) ==========
  {
    path: '/select-role',
    name: 'SelectRole',
    component: SelectRole, // Lazy load
    meta: { 
      requiresAuth: true,
      requiresRoleSelection: true, // Special flag for role selection
      title: 'Select Role'
    }
  },
  {
    path: '/select-company',
    name: 'SelectCompany',
    component: SelectCompany,
    meta: { 
      requiresAuth: true,
      requiresCompanySelection: true, // New flag
      title: 'Select Company'
    }
  },
  
  // ========== CATCH-ALL ROUTE ==========
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound, // Lazy load
    meta: { 
      requiresAuth: false,
      title: 'Page Not Found'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  
  // Optional: scroll behavior
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Helper function to check if user has selected a company
const hasSelectedCompany = (authStore) => {
  // For customer role, check if company is selected
  if (authStore.getCurrentRole === 'customer' || 
      (authStore.user?.roles?.includes('customer') && !authStore.hasMultipleRoles)) {
    return authStore.hasCompanySelected
  }
  
  // For other roles (employer, admin), company might not be required
  // Or you can implement role-specific logic
  return true // Assume other roles don't need company selection
}

// Helper function to check if user has required role
const hasRequiredRole = (userRoles, requiredRoles) => {
  if (!requiredRoles || requiredRoles.length === 0) {
    return true // No role requirement
  }
  
  if (!userRoles || userRoles.length === 0) {
    return false // User has no roles
  }
  
  // Check if user has at least one of the required roles
  return userRoles.some(role => requiredRoles.includes(role))
}

// Helper function to get appropriate redirect based on user's roles
const getRoleBasedRedirect = (userRoles) => {
  const authStore = useAuthStore()
  const currentRole = authStore.getCurrentRole
  
  // Use current role if set
  if (currentRole) {
    switch(currentRole) {
      case 'customer':
        return '/dashboard'
      case 'employer':
        return '/employer/dashboard'
      case 'admin':
        return '/admin/dashboard' // If you implement admin routes
      default:
        return '/dashboard'
    }
  }
  
  // If no current role, use the first available role
  if (userRoles && userRoles.length > 0) {
    switch(userRoles[0]) {
      case 'customer':
        return '/dashboard'
      case 'employer':
        return '/employer/dashboard'
      case 'admin':
        return '/admin/dashboard'
      default:
        return '/dashboard'
    }
  }
  
  // Default fallback
  return '/dashboard'
}

// Route guard to check authentication and roles
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // Set page title
  if (to.meta.title) {
    document.title = `${to.meta.title} | Almas Ai`
  }
  
  // ========== AUTHENTICATION CHECK ==========
  if (to.meta.requiresAuth) {
    // Check if user is authenticated
    if (authStore.isAuthenticated) {
      // Verify token is still valid
      const isValid = await authStore.checkAuth()
      
      if (!isValid) {
        // Token is invalid, redirect to login
        next('/login')
        return
      }
      
      // ========== COMPANY SELECTION CHECK ==========
      // Check if this route requires company selection (special flag)
      if (to.meta.requiresCompanySelection) {
        // This is the company selection page itself, allow access
        next()
        return
      }
      
      // Check if user needs company selection for customer role
      const currentRole = authStore.getCurrentRole
      const isCustomerRoute = currentRole === 'customer' || 
                             (to.meta.requiredRoles && to.meta.requiredRoles.includes('customer'))
      
      if (isCustomerRoute && !hasSelectedCompany(authStore)) {
        // User needs to select a company, redirect to company selection
        next('/select-company')
        return
      }
      
      // ========== ROLE SELECTION CHECK ==========
      // If route requires role selection and user has multiple roles but no selected role
      if (to.meta.requiresRoleSelection) {
        // This is the role selection page itself, allow access
        next()
        return
      }
      
      // If user has multiple roles but hasn't selected one yet
      if (authStore.hasMultipleRoles && !authStore.selectedRole) {
        // Redirect to role selection page
        next('/select-role')
        return
      }
      
      // ========== ROLE-BASED ACCESS CHECK ==========
      const userRoles = authStore?.getAvailableRoles || []
      const requiredRoles = to.meta.requiredRoles || []
      
      // Check if user has required role(s)
      if (!hasRequiredRole(userRoles, requiredRoles)) {
        // User doesn't have required role, redirect to appropriate dashboard
        
        // First check if they need company selection
        if (authStore.needsCompanySelection) {
          next('/select-company')
          return
        }
        
        const redirectTo = getRoleBasedRedirect(userRoles)
        
        // Show error message (optional)
        if (process.env.NODE_ENV !== 'production') {
          console.warn(`Access denied. User roles: ${userRoles.join(', ')}, Required: ${requiredRoles.join(', ')}`)
        }
        
        next(redirectTo)
        return
      }
      
      // All checks passed, allow access
      next()
      
    } else {
      // Not authenticated, redirect to login
      // Save the intended destination for redirect after login
      if (to.path !== '/login') {
        authStore.redirectPath = to.fullPath
      }
      next('/login')
    }
  } 
  
  // ========== HIDE WHEN AUTHENTICATED CHECK ==========
  else if (to.meta.hideWhenAuthenticated && authStore.isAuthenticated) {
    // User is authenticated but trying to access login/register pages
    // Redirect to appropriate dashboard based on role
    
    // Check if they need company selection first
    if (authStore.needsCompanySelection) {
      next('/select-company')
      return
    }
    
    // Check if they need role selection
    if (authStore.hasMultipleRoles && !authStore.selectedRole) {
      next('/select-role')
      return
    }
    
    const userRoles = authStore.user?.roles || []
    const redirectTo = getRoleBasedRedirect(userRoles)
    next(redirectTo)
  }
  
  // ========== PUBLIC ROUTE ==========
  else {
    next()
  }
})

// Optional: After each route navigation
router.afterEach((to, from) => {
  // You can add analytics tracking here
  if (process.env.NODE_ENV !== 'production') {
    console.log(`Navigated from ${from.path} to ${to.path}`)
  }
})

export default router
